import './apiAuth'
import { ensureMemberSession } from './utils/memberSession'
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import firebase from 'firebase/app'
import 'firebase/auth'
import { defaultLineSettings } from '@/constants/lineSettings'
import VModal from 'vue-js-modal'
import VueConfirmDialog from 'vue-confirm-dialog'
import VueSweetalert2 from 'vue-sweetalert2'
import { Swiper as SwiperClass, Pagination, Mousewheel, Autoplay } from 'swiper/swiper.esm'
import getAwesomeSwiper from 'vue-awesome-swiper/dist/exporter'
import VueClipboard from 'vue-clipboard2'
VueClipboard.config.autoSetContainer = true // add this line
Vue.use(VueClipboard)
SwiperClass.use([Pagination, Mousewheel, Autoplay])
Vue.use(getAwesomeSwiper(SwiperClass))
const { Swiper, SwiperSlide } = getAwesomeSwiper(SwiperClass)
import 'swiper/swiper-bundle.css'
import 'sweetalert2/dist/sweetalert2.min.css';
import '@/assets/css/login.css'
import '@/assets/css/member-pages.css'
//import '@/assets/css/main.css'
const options = {
  confirmButtonColor: '#FFD74C',
  cancelButtonColor: '#ff7674'
}
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  // set observer to true
  observer: true,
  preLoad: 1.3,
  // optional
  observerOptions: {
    rootMargin: '0px',
    threshold: 0.1
  }
})
Vue.use(VueSweetalert2, options)
Vue.use(VModal)
Vue.use(VueConfirmDialog)
Vue.component('vue-confirm-dialog', VueConfirmDialog.default)
const configFirebase = {
  apiKey: "AIzaSyClcxp3x2WpOwxQH_viCn5guyCGCQ07Ln8",
  authDomain: "xxmac-co.firebaseapp.com",
  databaseURL: "https://xxmac-co-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "xxmac-co",
  storageBucket: "xxmac-co.appspot.com",
  messagingSenderId: "1056559869284",
  appId: "1:1056559869284:web:4f7bf9b539c5d318545e71"
}
firebase.initializeApp(configFirebase)
Vue.config.productionTip = false
const lineDefaults = defaultLineSettings
Vue.mixin({
  computed: {
    lineSettings (): { lineAt: string; linkLine: string } {
      const storeRef = (this as any).$store
      const settings = storeRef && storeRef.state && storeRef.state.user && storeRef.state.user.lineSettings
      return settings || lineDefaults
    },
    lineAt (): string {
      const settings = (this as any).lineSettings as { lineAt: string }
      return settings.lineAt || defaultLineSettings.lineAt
    },
    lineLink (): string {
      const settings = (this as any).lineSettings as { linkLine: string }
      return settings.linkLine || defaultLineSettings.linkLine
    }
  }
})
Vue.prototype.$music = null
let app: any
firebase.auth().onAuthStateChanged(async () => {
  if (!app) {
    await store.dispatch('user/loadLineSettings')
    app = new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount('#app')
  }
})
